export default __webpack_public_path__ + "static/media/loading-dark.c5bd2bb2.gif";